<template>
  <div class="events">
    <van-tabs
      v-model="active"
      class="eventtab"
    >
      <!-- <van-tab
        :title="$t('common.p4')"
        name="ppwc"
        class="ppwc"
      >
        <div class="banner">
          <van-swipe :show-indicators="false">
            <van-swipe-item
              v-for="(item, index) in 1"
              :key="index"
            >
              <div
                class="banner_img"
              >
                <img
                  src="/official_mobile/static/img/ppwc/banner.jpg"
                  alt="banner"
                >
              </div>
            </van-swipe-item>
          </van-swipe>
        </div>

        <div class="upcoming">
          <events-home />
        </div>

        <div class="divider_color" />

        <div class="about green_bg">
          <div class="about-top">
            <h2 class="title">
              {{ $t('common.p64') }}
            </h2>
            <img
              class="image"
              src="/official_mobile/static/img/ppwc/logo.png"
            >
          </div>

          <div class="line green" />
          <div class="content">
            <p>{{ $t('event.p2') }}</p>
            <p>{{ $t('event.p3') }}</p>
          </div>
        </div>

        <div class="divider_color" />

        <div class="past_event">
          <h2 class="past-title">
            {{ $t('common.p60') }}
          </h2>
          <div class="line" />
          <div class="content">
            <van-tabs
              v-model="ppwc_active"
              class="ppwctab"
            >
              <van-tab
                :title="$t('common.p61')"
                name="report"
                class="report"
              >
                <div>
                  <div class="bg_video">
                    <div>
                      <h3 class="title">
                        VIDEO REVIEW
                      </h3>
                    </div>
                    <video
                      id="player"
                      ref="video"
                      poster="/official_mobile/static/img/events/home_video.jpg"
                      playsinline
                      controls
                    >
                      <source
                        :src="'/official_mobile/static/img/events/ppwc_mobile.mp4'"
                        type="video/mp4"
                      >Your browser does not support the video tag.
                    </video>
                  </div>

                  <div>
                    <h3 class="title">
                      {{ $t('common.p63') }}
                    </h3>
                  </div>

                  <div class="all_days">
                    <van-row>
                      <van-col span="12">
                        <a @click="toReportCon(1)">
                          <img
                            class="image"
                            src="/official_mobile/static/img/events/1.jpg"
                          >
                        </a>
                      </van-col>
                      <van-col span="12">
                        <a @click="toReportCon(2)">
                          <img
                            class="image"
                            src="/official_mobile/static/img/events/2.jpg"
                          >
                        </a>
                      </van-col>
                      <van-col span="12">
                        <a @click="toReportCon(3)">
                          <img
                            class="image"
                            src="/official_mobile/static/img/events/3.jpg"
                          >
                        </a>
                      </van-col>
                      <van-col span="12">
                        <a @click="toReportCon(4)">
                          <img
                            class="image"
                            src="/official_mobile/static/img/events/4.jpg"
                          >
                        </a>
                      </van-col>
                      <van-col span="12">
                        <a @click="toReportCon(5)">
                          <img
                            class="image"
                            src="/official_mobile/static/img/events/5.jpg"
                          >
                        </a>
                      </van-col>
                      <van-col span="12">
                        <a @click="toReportCon(6)">
                          <img
                            class="image"
                            src="/official_mobile/static/img/events/6.jpg"
                          >
                        </a>
                      </van-col>
                      <van-col span="24">
                        <a @click="toReportCon(7)">
                          <img
                            class="image"
                            src="/official_mobile/static/img/events/7.jpg"
                          >
                        </a>
                      </van-col>
                    </van-row>
                  </div>
                </div>
              </van-tab>
              <van-tab
                :title="$t('common.p62')"
                name="result"
                class="result"
              >
                <div class="mobile-table">
                  <div
                    v-for="(item, index) in schedule"
                    :key="index"
                    class="cont"
                  >
                    <div
                      v-if="index == '0' || item.date != schedule[index-1].date"
                      class="head-title"
                    >
                      <p>{{ item.date }}</p>
                    </div>
                    <div class="cont-con">
                      <div
                        class="cont-p"
                        :class="{grey: item.state == '3'}"
                      >
                        <p>
                          {{ $t('common.p65') }}:
                          <b>{{ item.time }}</b>
                        </p>
                        <p>
                          {{ $t('common.p67') }}:
                          <b>{{ item.name }}</b>
                        </p>
                        <p>
                          Buy in:
                          <b>{{ item.buyin | formatZeroMobile }}</b>
                        </p>
                        <div class="height-center">
                          <a
                            :href="'privacyPolicy.html/images/' + encodeURIComponent(item.images[0])"
                            class="cont-but1"
                          >
                            <p>{{ $t('common.p70') }}</p>
                          </a>
                          <a
                            v-if="item.state != '3'"
                            class="cont-but2 disabled"
                          >
                            <p>{{ $t('common.p71') }}</p>
                          </a>
                          <a
                            v-if="item.state == '3'"
                            class="cont-but2"
                            :href="'/events/schedule/' + item.id"
                          >
                            <p>{{ $t('common.p71') }}</p>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </van-tab>
            </van-tabs>
          </div>
        </div>
        <div class="divider_color" />
      </van-tab> -->
      <van-tab
        :title="$t('common.p5')"
        name="festival"
      >
        <festival />
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
// @ is an alias to /src
import festival from './festival.vue'
// import eventsHome from './eventsHome.vue'

export default {
  components: {
    festival,
    // eventsHome
  },
  filters: {
    formatZero (data) {
      if (data === '0') {
        return '-'
      } else {
        return (data || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
      }
    },
    formatZeroMobile (data) {
      if (data === '0') {
        return '-'
      } else {
        return (
          'PHP ' + (data || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
        )
      }
    }
  },
  data () {
    return {
      active: 'ppwc',
      eventName: 'pastevent',
      ppwc_active: 'report',
      report: true,
      items: [
        { name: 'Day1', index: '1' },
        { name: 'Day2', index: '2' },
        { name: 'Day3', index: '3' },
        { name: 'Day4', index: '4' },
        { name: 'Day5', index: '5' },
        { name: 'Day6', index: '6' },
        { name: 'FinalDay', index: '7' }
      ],
      report_index: '1',
      result_status: true,
      result_index: '1',
      schedule: [],
      result: {
        images: []
      },
      page: {
        now: 1,
        tota: 1,
        per_num: 10
      },
      scroll: 0
    }
  },
  computed: {
    images: function () {
      let nums = {
        pc: {
          '1': ['1_01', '1_02', '1_03', '1_04', '1_05', '1_06', '1_07'],
          '2': ['2_01', '2_02', '2_03', '2_04', '2_05', '2_06', '2_07'],
          '3': [
            '3_01',
            '3_02',
            '3_03',
            '3_04',
            '3_05',
            '3_06',
            '3_07',
            '3_08',
            '3_08',
            '3_10'
          ],
          '4': ['4_01', '4_02', '4_03', '4_04', '4_05', '4_06', '4_07'],
          '5': ['5_01', '5_02', '5_03', '5_04', '5_05', '5_06', '5_07'],
          '6': ['6_01', '6_02', '6_03', '6_04', '6_05', '6_06', '6_07', '6_08'],
          '7': ['7_01', '7_02', '7_03', '7_04', '7_05', '7_06', '7_07']
        }
      }
      let desize = 'pc'

      return nums[desize][this.report_index].map(item => {
        return desize + '/' + this.report_index + '/images/' + item
      })
    }
  },
  created () {
    this.$store.commit('changeTab', 1)
    this.getlist()
  },
  mounted () {
    // window.addEventListener('scroll', this.handleScroll)
    document.querySelector('#app').addEventListener('scroll', this.handleScroll)
  },
  activated () {
    // if (this.scroll > 0) {
    document.querySelector('#app').scrollTo(0, this.scroll)
    // this.scroll = 0
    document.querySelector('#app').addEventListener('scroll', this.handleScroll)
    // }
  },
  deactivated () {
    document.querySelector('#app').removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    getlist () {
      this.$axios
        .get('/poker-api/competition/schedules')
        .then(res => {
          if (res.status === 200 && res.data.code === 0) {
            this.schedule = res.data.data
            this.page.total = Math.ceil(
              res.data.data.length / this.page.per_num
            )
          } else {
            alert('network issue, Please try again later.')
          }
        })
        .catch(() => {
          alert('network issue, Please try again later.')
        })
    },
    updateResultCon (id) {
      this.$axios
        .get('/poker-api/competition/result', {
          params: {
            id
          }
        })
        .then(res => {
          if (res.status === 200 && res.data.code === 0) {
            this.result = res.data.data.result
          } else {
            alert('network issue, Please try again later.')
          }
        })
        .catch(() => {
          alert('network issue, Please try again later.')
        })
    },
    changePage (page) {
      this.page.now += page
    },
    toReportCon (num) {
      // this.report = false
      // this.report_index = num.toString()
      // document.querySelector('.middle').scrollIntoView({ block: 'start', behavior: 'smooth' })
      this.$router.push({
        name: 'events-ppwc',
        params: { item: num.toString() }
      })
    },
    toResultCon (id) {
      console.log(id)
      this.result_status = false
      this.result_index = id
      this.updateResultCon(id)
      document
        .querySelector('.middle')
        .scrollIntoView({ block: 'start', behavior: 'smooth' })
    },
    handleScroll (scr) {
      this.scroll = document.querySelector('#app') && document.querySelector('#app').scrollTop
      console.log('event', this.scroll)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.events {
  position: relative;
  padding: 20px 0px 0px 0px;
  width: 100%;
  .eventtab {
    /deep/.van-tabs__nav {
      background-color: inherit;
    }
    /deep/.van-hairline--top-bottom::after,
    /deep/.van-hairline-unset--top-bottom::after {
      border: none;
    }
    /deep/.van-ellipsis {
      font-size: 28px;
      color: #a6a6a6;
    }
    /deep/.van-tab--active {
      .van-ellipsis {
        color: #269853;
      }
    }
    /deep/.van-tabs__line {
      background-color: #269853;
    }
    /deep/.van-tabs__content {
      margin-top: 26px;
      border-top: 1px solid #c0c0c0;
      // padding: 0px 24px 20px 24px;
    }
  }

  h2 {
    margin: 0px;
    padding: 0px;
  }

  .ppwc {
    // padding: 0px 24px;
    // background-color: #2a2a2a;
    .banner {
      position: relative;
      width: 100%;
      // z-index: 1;
      .banner_img {
        display: block;
        width: 100%;
        // height: 771px;
        // background-position: center center;
        // background-repeat: no-repeat;
        img {
          width: 100%;
          height: 510px;
          display: block;
        }
        .banner_btn {
          position: absolute;
          width: 276px;
          height: 70px;
          right: 237px;
          bottom: 15px;
          background-image: url("/official_mobile/static/img/ppwc/banner_btn.png");
          background-size: 100% auto;
          background-repeat: no-repeat;
          text-align: center;
          cursor: pointer;
          p {
            line-height: 53px;
            font-size: 20px;
            font-weight: bold;
            color: #ffffff;
          }
        }
      }
    }
    .upcoming {
      // background-color: transparent;
      // border-width: 40px 0px 40px 0px;
      // border-style: solid;
      // border-image-slice: 40 0 40 0 fill;
      // border-image-repeat: stretched;
      // border-image-source: url("/official_mobile/static/img/bg/ppwc/01.png");

      padding: 40px 24px 60px 24px;
      .title {
        font-size: 30px;
        margin: 10px 0px 40px 0px;
      }
      .line {
        border-top: 2px solid #4d4646;
      }
      .content {
        font-size: 20px;
        .to_be_announced {
          position: relative;
          .to_be_announced_p {
            position: absolute;
            width: 100%;
            height: 50px;
            left: 0px;
            top: 40px;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 28px;
          }
          img {
            display: inline-block;
            width: 100%;
          }
        }
        .con-item {
          padding: 22px 0px;
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          border-bottom: 2px solid #c0c0c0;
          .image {
            display: block;
            width: 188px;
          }
          .con-p {
            width: 480px;
            .subtitle {
              font-size: 28px;
            }
            p {
              font-size: 22px;
            }
          }
        }
      }
    }
    .about {
      position: relative;
      // background-color: transparent;
      // border-width: 40px 0px 40px 0px;
      // border-style: solid;
      // border-image-slice: 40 0 40 0 fill;
      // border-image-repeat: stretched;
      // border-image-source: url("/official_mobile/static/img/bg/ppwc/02.png");

      padding: 0px 24px 0px 24px;
      .about-top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-top: 30px;
        margin-bottom: 30px;
        .title {
          font-size: 30px;
          color: #fff;
        }
        .image {
          width: 162px;
        }
      }
      .line {
        margin-bottom: 30px;
      }
      .content {
        padding-bottom: 30px;
        p {
          // font-size: 26px;
          color: #fff;
          margin-bottom: 30px;
          line-height: 46px;
          a {
            color: #fff;
            // box-shadow: 0 1px;
            text-decoration: underline;
          }
        }
      }
    }
    .past_event {
      position: relative;
      padding: 30px 0px 30px 0px;

      // background-color: transparent;
      // border-width: 30px 0px 30px 0px;
      // border-style: solid;
      // border-image-slice: 30 0 30 0 fill;
      // border-image-repeat: stretched;
      // border-image-source: url("/official_mobile/static/img/bg/ppwc/03.png");
      .ppwctab {
        /deep/.van-tabs__content {
          border-top: none;
        }
      }
      .past-title {
        font-size: 30px;
        color: #279754;
        margin: 10px 0px 40px 0px;
        padding: 0px 24px 0px 24px;
      }
      .line {
        margin: 0px 24px 40px 24px;
        // border-top: 2px solid #4d4646;
        // margin-bottom: 40px;
      }
      .report {
        padding: 12px 24px 60px 24px;
        // background-color: #1e1e1e;
        .title {
          font-size: 24px;
          // color: #ffffff;
        }
        .bg_video {
          padding: 18px 24px;
          width: 702px;
          margin-left: -24px;
          // background-image: url("/official_mobile/static/img/events/bg_4.jpg");
          #player {
            width: 100%;
          }
        }
        .all_days {
          margin: 0 -6px;
          a {
            display: block;
            padding: 6px;
          }
          .image {
            width: 100%;
            display: block;
          }
        }
      }
      .result {
        padding-bottom: 40px;
        .mobile-table {
          font-size: 1rem;
          .cont {
            width: 100%;
            .head-title {
              width: 100%;
              height: 0.93333em;
              text-align: center;
              background-color: #e4e4e4;
              p {
                font-size: 0.3733em;
                line-height: 2.5em;
                font-weight: bold;
                color: #727272;
              }
            }
            .cont-con {
              width: 100%;
              // min-height: 2.76em;
              position: relative;
              // border-bottom: 1px solid #f5f5f5;
              .cont-p.grey {
                color: #929292;
              }
              .cont-p {
                width: 6.3em;
                padding: 30px 0px 30px 0.58em;
                display: inline-block;
                p {
                  padding: 0px;
                  margin: 0px;
                  font-size: 26px;
                  line-height: 40px;
                  // color: #999999;
                }
                .height-center {
                  position: absolute;
                  top: 50%;
                  transform: translateY(-50%);
                  right: 0.58em;
                  .cont-but1,
                  .cont-but2 {
                    display: block;
                    width: 180px;
                    height: 52px;
                    background-color: #279754;
                    text-align: center;
                    // border-radius: 0.1em;
                    p {
                      color: #fff;
                      font-size: 22px;
                      line-height: 52px;
                    }
                  }
                  .cont-but2 {
                    margin-top: 0.26em;
                  }
                  .cont-but2.disabled {
                    background-color: #a0a0a0;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
